import { CodeComplexValue } from 'app/area/shared/codetable/types';
import { SerializePayload } from 'app/area/search-filters/types';
import { CodeFieldIncludeInactive } from 'app/area/import-mappings/types-store';
import { LoadOptions, Value } from 'app/types-shared';
import { FilterSearchModel } from 'app/area/search-filters/types-store';
import { ValidationProps } from 'ui';
import { ImportMappingsTranslation } from 'app/area/import-mappings/constants';

import type { JSX } from "react";

export const codeSearchArea = 'code';

export interface LoadCodeItems {
  payload?: SerializePayload;
  importSet?: CodeComplexValue<number>;
  codetable?: CodeComplexValue<number>;
  category?: CodeComplexValue<number>;
  parent?: {
    id: number;
    startIndex: number;
  };
}

export interface CodetableOptions {
  fetching: boolean;
  loadOptionsParams: LoadOptions;
  codes: CodeComplexValue<number>[];
  currentOptions: CodeComplexValue<number>[];
}

export interface CodeFieldWire {
  id: number;
  searchRequired: boolean;
  label?: string;
}

export interface CodetableMetadataWire {
  category: CodeFieldWire;
  code: CodeFieldWire;
  application: boolean;
  label: string;
  disabled: boolean;
  sequence: boolean;
  hierarchy: boolean;
}

export interface LoadCodeItemsParams {
  id: number;
  importSetId: number;
  parentId?: number;
  siblingId?: number;
  categoryId?: number;
  query?: string;
  model?: FilterSearchModel;
  startIndex?: number;
  maxResults?: number;
  displayNotSelected?: boolean;
  limitFieldsTo?: string[];
  includeInactiveCodes?: CodeFieldIncludeInactive;
  ignoreCategoryFilters?: boolean;
  includeNotSelected?: boolean;
}

export interface ImportMappingWire {
  importNumber: number;
  externalValue: string;
}

export interface CodeListItemWire {
  code: Value;
  disabled?: string;
  category?: Value;
  codeCategory?: Value;
  descendantCount: number;
  importMapping: ImportMappingWire[];
}

export interface CodeListWire {
  totalNumberOfResults: number;
  results: CodeListItemWire[];
}

export interface CategoryOptionsWire {
  totalNumberOfResults: number;
  results: CodeListItemWire[];
}

export interface LoadCategoryOptionsParams {
  id?: number;
  parentId?: number;
  siblingId?: number;
  categoryId?: number;
  query?: string;
  displayNotSelected?: boolean;
  returnLeavesOnly?: boolean;
  limitFieldsTo?: string[];
  includeNotSelected?: boolean;
  includeDisabled?: boolean;
  code?: { text: number | string };
}

export interface CategorySinglePickerState {
  loadedOptions: LoadOptions;
}

export interface CategorySinglePickerProps {
  id: string;
  label: string;
  required?: boolean;
  searchRequired?: boolean;
  enableMultilineValidation?: boolean;
  options: CodeComplexValue<number>[];
  fetchingOptions: boolean;
  translation: ImportMappingsTranslation;
  displayCategories?: boolean;
  categoryOptions?: CodeComplexValue<number>[];
  categoryId?: number;
  valueItem: CodeComplexValue<number>;
  validation?: ValidationProps;
  readOnly?: boolean;
  leafNodeOnly?: boolean;
  showBackgroundColour?: boolean;
  includeDisabledLabel?: string;
  showSpinnerLabel?: boolean;
  minLength?: number;
  onChange: (value: CodeComplexValue<number>) => void;
  extraFooterButton?: (onCloseCallback: (onClose: void) => void) => JSX.Element;
  onLoadOptions: (id: string, loadOptionsParams: LoadOptions) => void;
  onLoadCategoryOptions?: (loadOptions: LoadOptions) => void;
}
